"use client";

import { useLanguage } from "@/contexts/LanguageContext";

export default function SectionRetention() {
  const { t } = useLanguage();

  const points = [
    {
      key: "0",
      icon: (
        <svg
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="w-8 h-8 text-brand-secondary"
          role="img"
          aria-labelledby="icon-sales"
        >
          <title id="icon-sales">
            {t("sectionRetention.points.0.iconTitle")}
          </title>
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
          />
        </svg>
      ),
    },
    {
      key: "1",
      icon: (
        <svg
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="w-8 h-8 text-brand-secondary"
          role="img"
          aria-labelledby="icon-waste"
        >
          <title id="icon-waste">
            {t("sectionRetention.points.1.iconTitle")}
          </title>
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
          />
        </svg>
      ),
    },
    {
      key: "2",
      icon: (
        <svg
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="w-8 h-8 text-brand-secondary"
          role="img"
          aria-labelledby="icon-security"
        >
          <title id="icon-security">
            {t("sectionRetention.points.2.iconTitle")}
          </title>
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M9 12.75 11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 0 1-1.043 3.296 3.745 3.745 0 0 1-3.296 1.043A3.745 3.745 0 0 1 12 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 0 1-3.296-1.043 3.745 3.745 0 0 1-1.043-3.296A3.745 3.745 0 0 1 3 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 0 1 1.043-3.296 3.746 3.746 0 0 1 3.296-1.043A3.746 3.746 0 0 1 12 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 0 1 3.296 1.043 3.746 3.746 0 0 1 1.043 3.296A3.745 3.745 0 0 1 21 12Z"
          />
        </svg>
      ),
    },
    {
      key: "3",
      icon: (
        <svg
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="w-8 h-8 text-brand-secondary"
          role="img"
          aria-labelledby="icon-dependency"
        >
          <title id="icon-dependency">
            {t("sectionRetention.points.3.iconTitle")}
          </title>
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z"
          />
        </svg>
      ),
    },
  ];

  return (
    <section
      id="problemas"
      className="bg-surface-card py-24 px-6 md:px-12 text-text-primary relative"
    >
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-4xl font-bold text-center mb-12 tracking-tight">
          {t("sectionRetention.title.before")}{" "}
          <span className="text-brand-primary bg-clip-text text-transparent bg-gradient-to-r from-brand-primary to-brand-secondary">
            {t("sectionRetention.title.highlight")}
          </span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {points.map((p) => (
            <div
              key={p.key}
              className="bg-surface-elevated p-8 rounded-xl border border-border-default hover:border-brand-secondary/40 transition-all duration-300 hover:shadow-[0_0_30px_-10px_rgba(24,84,240,0.15)] group"
            >
              <div className="mb-6 bg-border-default w-10 h-10 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform">
                {p.icon}
              </div>
              <h3 className="text-xl font-bold mb-3 text-text-primary group-hover:text-text-primary">
                {t(`sectionRetention.points.${p.key}.title`)}
              </h3>
              <p className="text-text-secondary leading-relaxed text-sm group-hover:text-text-primary">
                {t(`sectionRetention.points.${p.key}.desc`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
